module.exports = __webpack_public_path__ + "img/logo-seadevil-small@2x.0564475a.png";